import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex items-center" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "radio",
      class: "form-radio",
      name: "radio",
      value: _ctx.option,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.radioChangeEvent && _ctx.radioChangeEvent(...args)))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.option), 1)
  ]))
}